export const VARIANTS = ['solid', 'subtle', 'left-accent', 'top-accent', 'bottom-accent'];
export const DEFAULT_PROPS = {
    variant: 'solid',
};
